<template>
  <div>
    <div v-if="apps.length" class="flex items-center align-middle">
      <vx-tooltip :text="app.name" v-for="(app, gIndex) in apps" style="margin-top: 2px" :key="gIndex">
        <vs-avatar :src="app.icon" :text="app.name | capitalize" class="flex-shrink-0 mr-2" size="30px" />
      </vx-tooltip>
    </div>
    <div v-else class="flex items-center align-middle">None</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      apps: []
    }
  },
  methods: {
    fetchAppDetails (id) {
      this.$httpCached
        .get(`platform/apps/${id}?cc=course_subscription_table_user_app`, {
          ttl: 15
        })
        .then((response) => {
          if (response.status === 200) {
            this.apps.push(response.data.data)
          }
        })
    }
  },
  created () {
    const apps = this.params.value.sort()
    apps.forEach((app) => {
      this.fetchAppDetails(app)
    })
  }
}
</script>
